// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ListOverview_wrapper__CQ7wX"};